export default __webpack_public_path__ + "static/media/speak_rus_upd.8f8e85b4.svg";